import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-tooltip', 'open', 'Atvērt papildu informāciju');
Labels.set('ui-tooltip', 'close', 'Aizvērt papildu informāciju');
